export class LocationModel {
    public locationId!: number;
    public displayName!: string;
    public locationName!: string;
    public isActive!: boolean;
    public locationTypeId!: LocationTypeId | string;
    public locationClass!: LocationClass | string;
    public parentId!: number;

    public parentName: string;
}

export enum LocationTypeId {
    Division = 1,
    Region = 2,
    District = 3,
    Retail = 4,
    Company = 5,
}

export enum LocationClass {
    Store = 1,
    WareHouse = 2,
}
